<template>
  <div id="app">
    <cover/>
    <TheNavigation/>
    <router-view :key="$route.fullPath"/>
  </div>
</template>

<script>
  import TheNavigation from "../views/TheNavigation"
  import cover from '../views/cover'

  export default{
    name: 'app',
    components: {
      TheNavigation,
      cover
    },
    created() {
      this.$store.dispatch('getTags')
      this.$store.dispatch('getProjects')
      this.$store.dispatch('getBlogs')
      this.$store.dispatch('getExperiences')
    }
  }
</script>

<style lang="scss" scoped>
</style>
